import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent } from 'react';

import { PageData } from '../PageTemplate';
import { ArticlePageSEO } from './ArticlePageSEO';
import { BasicSeoElements } from './BasicSEO';
import { CategoryPageSEO } from './CategoryPageSEO';
import { HomePageSEO } from './HomePageSEO';
import { SearchResultsPageSEO } from './SearchResultsPageSEO';
import { PageSeo, PageType } from '../../types';

type SEOProps = {
  pageType: PageType;
  pageData: PageData;
  pageSeo: PageSeo | null;
};

export const SEO: FunctionComponent<SEOProps> = ({
  pageType,
  pageData,
  pageSeo,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {(() => {
        switch (pageType) {
          case PageType.KnownIssues:
          case PageType.Category:
            return (
              <CategoryPageSEO
                category={pageData.category}
                pageSeo={pageSeo}
                translations={pageData.translations}
              />
            );
          case PageType.Article:
            return (
              <ArticlePageSEO
                article={pageData.article}
                pageSeo={pageSeo}
                categoriesTree={pageData.categoriesTree}
              />
            );
          case PageType.SearchResults:
            return (
              <SearchResultsPageSEO pageSeo={pageSeo} term={pageData.term} />
            );
          case PageType.Homepage:
            return <HomePageSEO pageSeo={pageSeo} />;
          case PageType.RoadMap:
            return <BasicSeoElements title={t('wix-product-roadmap-title')} />;
          case PageType.Profile:
          case PageType.Ticket:
            return (
              <BasicSeoElements
                title="Wix Support"
                robots={{
                  noArchive: false,
                  noFollow: true,
                  noIndex: true,
                }}
              />
            );
          default:
            return <BasicSeoElements title="Wix Support" />;
        }
      })()}
    </>
  );
};
